import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewEncapsulation,
} from '@angular/core';

import { AnalyticsService } from '../../../services/analytics-wrapper/analytics.service';
import { CMSContentStoreService } from '../../../services/cms-content-store/cms-content-store.service';

import { SanitizeHtmlPipe } from '../../../pipes/sanitizer/sanitize-html.pipe';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SanitizeHtmlPipe],
})
export class FooterComponent implements OnInit, OnDestroy {
  footerContentHtml: string;
  ngUnsubscribe = new Subject<void>();
  prevFooterToggle: any;
  private rendererListener: () => void;

  constructor(
    private readonly _cmsContentStoreService: CMSContentStoreService,
    private readonly renderer: Renderer2,
    readonly elementRef: ElementRef,
    private readonly analyticsService: AnalyticsService,
  ) {}

  /**
   * ngOnInit life cycle hook
   */
  ngOnInit() {
    this.getHtml();
    this.rendererListener = this.renderer.listen(
      this.elementRef.nativeElement,
      'click',
      (event) => {
        if (event.target instanceof HTMLAnchorElement) {
          this.trackFooterClick(event);
        }
        if (event.target.closest('.ups-footer-toggle')) {
          this.toggleFooterPanel(event.target.closest('.ups-footer-toggle'));
        }
      },
    );
  }

  /**
   * if clicked target is expansion panel, then toggle it
   * @param target click event target
   */
  toggleFooterPanel(target: any) {
    if (!target.classList.contains('ups-active')) {
      if (this.prevFooterToggle) {
        this.prevFooterToggle.classList.remove('ups-active');
        this.prevFooterToggle.nextElementSibling?.classList.remove(
          'ups-active',
        );
        this.prevFooterToggle.children[1].ariaExpanded = false;
      }
      target.classList.add('ups-active');
      target.nextElementSibling?.classList.add('ups-active');
      target.children[1].ariaExpanded = true;
      this.prevFooterToggle = target;
    } else {
      target.classList.remove('ups-active');
      target.nextElementSibling?.classList.remove('ups-active');
      target.children[1].ariaExpanded = false;
    }
  }

  /**
   * custom anchor click event handler for analytics tracking
   * @param event click event
   */
  trackFooterClick(event: any) {
    const anchor: HTMLAnchorElement = event.target as HTMLAnchorElement;
    const linkName: string = anchor.innerText.split('\n')[0];
    this.analyticsService.createLinkClickTagObject(
      `${anchor.href}`,
      linkName,
      'Clicked on Footer Link',
      'Internal',
      { link_section: 'Clicked on Footer Link' },
    );
  }

  getHtml() {
    this.footerContentHtml =
      this._cmsContentStoreService.getValue('footer_content');
  }

  ngOnDestroy() {
    this.rendererListener();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
